// extracted by mini-css-extract-plugin
export var success = "success-module--success--3A4CP";
export var title = "success-module--title--3IKo3";
export var subtitle = "success-module--subtitle--23KRf";
export var media = "success-module--media--staRY";